(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7731],{

/***/ 2728:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ atoms_Accordion; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./common/contexts.js
var contexts = __webpack_require__(63228);
// EXTERNAL MODULE: ./common/functions.js
var functions = __webpack_require__(6644);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/atoms/Icon/fi/FiChevronDown.js
var FiChevronDown = __webpack_require__(46080);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./components/atoms/Accordion/context.js

/** ========== */ var context = /*#__PURE__*/ (0,react.createContext)({
    multipleOpen: false
});
/* harmony default export */ var Accordion_context = (context); /** ========== */ 

;// CONCATENATED MODULE: ./components/atoms/Accordion/context-item.js

/** ========== */ var contextItem = /*#__PURE__*/ (0,react.createContext)({
    eventKey: null,
    open: false
});
/* harmony default export */ var context_item = (contextItem); /** ========== */ 

;// CONCATENATED MODULE: ./components/atoms/Accordion/item.js






/**
 * contexts
 */ 


/** ========== */ var Component = function(_param) {
    var eventKey = _param.eventKey, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "eventKey",
        "children"
    ]);
    var active = (0,react.useContext)(contexts/* AccordionContext */.S).active;
    var open = active === null || active === void 0 ? void 0 : active.includes(eventKey);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(context_item.Provider, {
        value: {
            eventKey: eventKey,
            open: open
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            children: children({
                open: open
            })
        }))
    });
};
/* harmony default export */ var item = (Component);
Component.propTypes = {
    eventKey: (prop_types_default()).string.isRequired,
    children: (prop_types_default()).any.isRequired
}; /** ========== */ 

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 5 modules
var _to_consumable_array = __webpack_require__(10797);
;// CONCATENATED MODULE: ./components/atoms/Accordion/button.js







/**
 * contexts
 */ 


/** ========== */ var button_Component = function(_param) {
    var children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    var multipleOpen = (0,react.useContext)(Accordion_context).multipleOpen;
    var ref = (0,react.useContext)(contexts/* AccordionContext */.S), active = ref.active, setActive = ref.setActive;
    var eventKey = (0,react.useContext)(context_item).eventKey;
    /**
   * handle
   */ var handleOnClick = function(eventKey) {
        var listActive = (0,_to_consumable_array/* default */.Z)(active);
        var includes = listActive.includes(eventKey);
        if (multipleOpen) {
            setActive(includes ? listActive.filter(function(item) {
                return item !== eventKey;
            }) : (0,_to_consumable_array/* default */.Z)(listActive).concat([
                eventKey
            ]));
        } else {
            setActive(includes ? [] : [
                eventKey
            ]);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        onClick: function() {
            return handleOnClick(eventKey);
        },
        children: children
    }));
};
/* harmony default export */ var Accordion_button = (button_Component);
button_Component.propTypes = {
    children: (prop_types_default()).node.isRequired
}; /** ========== */ 

;// CONCATENATED MODULE: ./components/atoms/Accordion/panel.js






/**
 * contexts
 */ 
/** ========== */ var panel_Component = function(_param) {
    var children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    var ref = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(), height = ref1[0], setHeight = ref1[1];
    var open = (0,react.useContext)(context_item).open;
    /**
   * handle
   */ var handleHeight = function(ref) {
        setHeight(ref.current && ref.current.scrollHeight);
    };
    (0,react.useEffect)(function() {
        handleHeight(ref);
        window.addEventListener("resize", function() {
            return handleHeight(ref);
        });
        return function() {
            window.removeEventListener("resize", function() {
                return handleHeight(ref);
            });
        };
    }, [
        children
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        ref: ref,
        className: "overflow-hidden ".concat(props.className),
        style: {
            maxHeight: open ? "".concat(height, "px") : "0px"
        },
        children: children
    }));
};
/* harmony default export */ var panel = (panel_Component);
panel_Component.propTypes = {
    children: (prop_types_default()).node.isRequired
}; /** ========== */ 

;// CONCATENATED MODULE: ./components/atoms/Accordion/accordion-item.js





/**
 * contexts
 */ 
/**
 * components
 */ 


/** ========== */ var accordion_item_Component = function(_param) {
    var multipleOpen = _param.multipleOpen, defaultActiveKey = _param.defaultActiveKey, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "multipleOpen",
        "defaultActiveKey",
        "children"
    ]);
    // const [active, setActive] = useState(defaultActiveKey);
    // const [active, setActive] = useContext(AccordionContext);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion_context.Provider, {
        value: {
            multipleOpen: multipleOpen
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            children: children
        }))
    });
};
/* harmony default export */ var accordion_item = (Object.assign(accordion_item_Component, {
    Item: item,
    Button: Accordion_button,
    Panel: panel
}));
accordion_item_Component.propTypes = {
    multipleOpen: (prop_types_default()).bool,
    defaultActiveKey: (prop_types_default()).string,
    children: (prop_types_default()).node.isRequired
};
accordion_item_Component.defaultProps = {
    multipleOpen: false,
    defaultActiveKey: ""
}; /** ========== */ 

;// CONCATENATED MODULE: ./components/atoms/Accordion/index.js







/**
 * contexts
 */ /**
 * Accordions
 */ 
/** ========== */ /**
 * @param {Object} icon icon props for custom icon on accordion
 * @param {number} icon.className icon class that position of icon
 * @param {string} icon.openClass icon position on accordion opened
 * @param {string} icon.openClass icon position on accordion closed
 * @param {} myObj.c description
 */ var Accordion = function(_param) {
    var list = _param.list, defaultActiveKey = _param.defaultActiveKey, _multipleOpen = _param.multipleOpen, multipleOpen = _multipleOpen === void 0 ? false : _multipleOpen, icon = _param.icon, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "list",
        "defaultActiveKey",
        "multipleOpen",
        "icon",
        "children"
    ]);
    var active = (0,react.useContext)(contexts/* AccordionContext */.S).active;
    var IconElement = (0,react.useCallback)(function(open) {
        var IconTag = icon || FiChevronDown/* FiChevronDown */.b;
        if (/*#__PURE__*/ (0,react.isValidElement)(IconTag)) {
            return IconTag;
        } else if (Object.keys(IconTag).length > 0) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: IconTag.wrapperClass || (0,functions/* classNames */.A)(IconTag.wrapperSubclass, "absolute right-6 top-4 transform align-middle "),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconTag.Icon, {
                    className: (0,functions/* classNames */.A)(IconTag.className, "".concat(open ? IconTag.openClass || "rotate-180" : IconTag.closeClass || "rotate-0", " transition-all duration-200")),
                    size: IconTag.size || 20
                })
            });
        } else {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconTag, {
                className: "absolute right-6 top-4 transform align-middle  ".concat(open ? "rotate-180" : "rotate-0", " transition-all duration-200"),
                size: 20
            });
        }
    }, [
        icon
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(accordion_item, {
        multipleOpen: multipleOpen,
        defaultActiveKey: "".concat(active || ""),
        className: "gleads-accordion " + (props.className || ""),
        children: (list === null || list === void 0 ? void 0 : list.length) > 0 && list.map(function(item, index) {
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(accordion_item.Item, {
                eventKey: "".concat(item.name.toLowerCase().split(" ").join("-")),
                className: props.accordionClass && "".concat(props.accordionClass) || "last:mb-0",
                children: function(param) {
                    var open = param.open;
                    var ref, ref1, ref2, ref3;
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(accordion_item.Button, {
                                className: (0,functions/* classNames */.A)("relative w-full cursor-pointer  transition-colors duration-200", open ? ((ref = props.buttonWrapperClass) === null || ref === void 0 ? void 0 : ref.open) || "bg-gleads-oxfordBlue-800 text-white" : ((ref1 = props.buttonWrapperClass) === null || ref1 === void 0 ? void 0 : ref1.close) || "bg-white", props.buttonClass || "rounded-md py-4 px-6 pr-4 text-left font-semibold shadow-[0px_5px_20px_rgba(203,203,203,0.2)]"),
                                children: [
                                    IconElement(open),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: props.buttonContentClass ? open ? props.buttonContentClass.open : props.buttonContentClass.close : "pr-10 ",
                                        dangerouslySetInnerHTML: {
                                            __html: item.name
                                        }
                                    })
                                ]
                            }),
                            children ? /*#__PURE__*/ (0,jsx_runtime.jsx)(accordion_item.Panel, {
                                className: "gleads-accordion-panel transition-all ".concat(props.panelClass, " "),
                                children: children
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(accordion_item.Panel, {
                                className: "gleads-accordion-panel transition-all duration-200 ".concat(((ref2 = props.panelClass) === null || ref2 === void 0 ? void 0 : ref2.wrapperClass) || "mt-4", " "),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    dangerouslySetInnerHTML: {
                                        __html: item.content
                                    },
                                    className: ((ref3 = props.panelClass) === null || ref3 === void 0 ? void 0 : ref3.contentClass) || "mb-4 space-y-4"
                                })
                            })
                        ]
                    });
                }
            }, index);
        })
    });
};
/* harmony default export */ var atoms_Accordion = (Accordion);
Accordion.propTypes = {
    icon: (prop_types_default()).object,
    list: (prop_types_default()).array,
    multipleOpen: (prop_types_default()).bool,
    defaultActiveKey: (prop_types_default()).number
};
Accordion.defaultProps = {
    list: [],
    multipleOpen: false,
    defaultActiveKey: null
}; /** ========== */ 


/***/ }),

/***/ 68348:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports BalloonX, BalloonY */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _Index_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98504);
/* harmony import */ var _Index_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_Index_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var common_functions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6644);







/**
 *
 * @param {{
 * axis: "x" | "y";
 * }} props Props for the component
 *
 */ function Balloon(_param) {
    var axis = _param.axis, duration = _param.duration, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "axis",
        "duration",
        "children"
    ]);
    var animateEl = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    switch(axis){
        case "x":
            {
                animateEl = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BalloonX, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                    style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                        animationDuration: duration
                    }, props.style),
                    children: children
                }));
                break;
            }
        case "y":
            {
                animateEl = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BalloonY, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                    style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                        animationDuration: duration
                    }, props.style),
                    children: children
                }));
                break;
            }
        default:
            break;
    }
    return animateEl;
}
function BalloonX(_param) {
    var duration = _param.duration, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "duration",
        "children"
    ]);
    var pauseOnMobile = props.pauseOnMobile, classNames = props.classNames, otherProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, [
        "pauseOnMobile",
        "classNames"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        style: {
            animationDuration: duration
        },
        className: (0,common_functions__WEBPACK_IMPORTED_MODULE_1__/* .classNames */ .A)((_Index_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["animate-balloon"]), pauseOnMobile ? (_Index_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["animate-balloons-X-mobile"]) : (_Index_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["animate-balloons-X"]), classNames)
    }, otherProps), {
        children: children
    }));
}
function BalloonY(_param) {
    var duration = _param.duration, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "duration",
        "children"
    ]);
    var pauseOnMobile = props.pauseOnMobile, classNames = props.classNames, otherProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, [
        "pauseOnMobile",
        "classNames"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        style: {
            animationDuration: duration
        },
        className: (0,common_functions__WEBPACK_IMPORTED_MODULE_1__/* .classNames */ .A)((_Index_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["animate-balloon"]), pauseOnMobile ? (_Index_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["animate-balloons-Y-mobile"]) : (_Index_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["animate-balloons-Y"]), classNames)
    }, otherProps), {
        children: children
    }));
}
Balloon.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().element),
    axis: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    duration: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string)
};
Balloon.defaultProps = {
    axis: "x",
    duration: "4s"
};
/* harmony default export */ __webpack_exports__["ZP"] = (Balloon);


/***/ }),

/***/ 9035:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var components_atoms_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89577);
/* harmony import */ var _react_icons_all_files_fi_FiChevronDown__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39798);



/*** Vendors ***/ /*** components ***/ 

/*** ========== ***/ /**
 *
 * @param {{
 * }} props Props for the component
 *
 */ var FadeContent = function(_param) {
    var children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isFullView = ref[0], setIsFullView = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showButton = ref1[0], setShowButton = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), element = ref2[0], setElement = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), maxHeight = ref3[0], setMaxHeight = ref3[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var handleResize = function() {
            if (element) {
                var elementHeight = element.offsetHeight;
                if (elementHeight > window.innerHeight * 0.35) {
                    // Nếu chiều cao của element lớn hơn 35% chiều cao của window
                    // Thì ẩn đi 75% chiều cao element (chỉ hiện 35% nội dung cần xem) và hiện nút mũi tên sổ xuống
                    setShowButton(true);
                } else {
                    // Nếu chiều cao của element nhỏ hơn 35% chiều cao của window
                    // Thì hiện 100% chiều cao element (hiện đầy đủ nội dung cần xem)
                    setIsFullView(true);
                    setShowButton(false);
                }
                setMaxHeight(elementHeight);
            }
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return function() {
            window.removeEventListener("resize", handleResize);
        };
    }, [
        element
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "relative origin-bottom overflow-hidden transition-[max-height] duration-200 ease-linear ".concat(isFullView ? "h-full" : "bg-gradient-to-t from-white via-gleads-basic to-gleads-basic bg-clip-text text-transparent"),
                style: {
                    maxHeight: isFullView ? "".concat(element ? maxHeight : 0, "px") //show full max height
                     : "".concat(element ? maxHeight * 35 / 100 : 0, "px")
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    ref: function(el) {
                        if (!el) return;
                        setElement(el);
                    },
                    children: children
                })
            }),
            showButton && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "text-center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    className: "rounded-full border",
                    onClick: function(e) {
                        return setIsFullView(!isFullView);
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_icons_all_files_fi_FiChevronDown__WEBPACK_IMPORTED_MODULE_4__/* .FiChevronDown */ .b, {
                        size: 24,
                        className: "transition-transform duration-500 ".concat(isFullView ? "rotate-180" : "rotate-0")
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FadeContent);


/***/ }),

/***/ 89577:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var common_functions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6644);






/**
 *
 * @param {{
 * as: "a" | "button";
 * variant: "primary" | "outline" | "ghost";
 * btnTextStyle: "font-bold leading-5 text-sm";
 * status: "danger" | "light";
 * btnColor: "bg-gleads-buttonBlue-500 hover:bg-gleads-buttonBlue-600" | "bg-transparent hover:bg-gleads-buttonBlue-500" | "bg-transparent";
 * btnPadding: "px-6 py-3";
 * btnBorder: "border border-gleads-buttonBlue-500" | "border-0";
 * btnRounded: "rounded-md";
 * btnTextColor:"text-white hover:text-black";
 * onClick: function(){};
 * othersClass: "";
 * className: "";
 * }} props Props for the component
 *
 */ function Button(_param) {
    var as = _param.as, btnDisplay = _param.btnDisplay, useRouter = _param.useRouter, children = _param.children, variant = _param.variant, btnColor = _param.btnColor, status = _param.status, btnPadding = _param.btnPadding, btnTextColor = _param.btnTextColor, btnTextStyle = _param.btnTextStyle, btnBorder = _param.btnBorder, btnRounded = _param.btnRounded, othersClass = _param.othersClass, className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "as",
        "btnDisplay",
        "useRouter",
        "children",
        "variant",
        "btnColor",
        "status",
        "btnPadding",
        "btnTextColor",
        "btnTextStyle",
        "btnBorder",
        "btnRounded",
        "othersClass",
        "className"
    ]);
    var CustomTag = as;
    var commonStyles = "transition-colors duration-200 disabled:select-none disabled:bg-gray-400 ";
    var btnStyle;
    switch(variant){
        case "primary":
            btnStyle = [
                btnDisplay || "inline-block ",
                btnTextStyle || "font-bold leading-5 text-sm",
                btnColor || status === "danger" && "bg-gleads-pink-600 hover:bg-gleads-pink-500" || status === "light" && "bg-white hover:bg-gleads-buttonBlue-500" || "bg-gleads-buttonBlue-600 hover:bg-gleads-buttonBlue-500",
                btnRounded || "rounded-md",
                btnPadding || "px-6 py-3",
                btnTextColor || status === "light" && "text-gleads-basic hover:text-white" || "text-white",
                othersClass, 
            ].join(" ");
            break;
        case "outline":
            btnStyle = [
                btnDisplay || "inline-block ",
                btnTextStyle || "font-bold leading-5 text-sm",
                btnColor || "bg-transparent hover:bg-gleads-buttonBlue-500",
                btnRounded || "rounded-md",
                btnBorder || "border border-gleads-buttonBlue-500",
                btnPadding || "px-6 py-3",
                btnTextColor || "text-gleads-basic hover:text-white",
                othersClass, 
            ].join(" ");
            break;
        case "ghost":
            btnStyle = [
                btnDisplay || "inline-block ",
                btnTextStyle || "font-bold leading-5 text-sm",
                btnColor || "bg-transparent ",
                btnRounded || "rounded-md",
                btnBorder || "border-0",
                btnPadding || "px-6 py-3",
                btnTextColor || "text-gleads-buttonBlue-500 hover:text-gleads-buttonBlue-600",
                othersClass, 
            ].join(" ");
        default:
            break;
    }
    if (useRouter) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        className: className ? className : (0,common_functions__WEBPACK_IMPORTED_MODULE_1__/* .classNames */ .A)(commonStyles, btnStyle)
    }, props), {
        children: children
    }));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CustomTag, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        className: className ? className : (0,common_functions__WEBPACK_IMPORTED_MODULE_1__/* .classNames */ .A)(commonStyles, btnStyle)
    }, props), {
        children: children
    }));
}
Button.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().any),
    variant: prop_types__WEBPACK_IMPORTED_MODULE_5___default().oneOf([
        "primary",
        "outline",
        "ghost"
    ]),
    as: prop_types__WEBPACK_IMPORTED_MODULE_5___default().oneOf([
        "a",
        "button",
        "div",
        "span"
    ]),
    useRouter: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().bool)
};
Button.defaultProps = {
    variant: "primary",
    as: "button",
    useRouter: false
};
/* harmony default export */ __webpack_exports__["Z"] = (Button);


/***/ }),

/***/ 46219:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CheckContent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/atoms/Icon/iconBase.js + 1 modules
var iconBase = __webpack_require__(52624);
;// CONCATENATED MODULE: ./components/atoms/Icon/fa/FaCheckCircle.js

function FaCheckCircle(props) {
    return (0,iconBase/* GenIcon */.w)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"
                }
            }
        ]
    })(props);
}
;

;// CONCATENATED MODULE: ./components/atoms/CheckContent/index.js





function CheckContent(_param) {
    var data = _param.data, icon = _param.icon, props = (0,_object_without_properties/* default */.Z)(_param, [
        "data",
        "icon"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: "mt-2 first:mt-0"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex items-start ",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: icon || /*#__PURE__*/ (0,jsx_runtime.jsx)(FaCheckCircle, {
                        size: 16,
                        className: "mr-2 mt-1 text-gleads-basic"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    dangerouslySetInnerHTML: {
                        __html: data
                    }
                })
            ]
        })
    }));
};


/***/ }),

/***/ 9945:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ Descriptions; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);





/**
 * vendor
 */ /**
 * styles
 */ /** ========== */ var Description = function(_param) {
    var list = _param.list, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "list"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props), {
        className: "".concat(props.className ? "".concat(props.className) : "text-base text-black"),
        style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props.style),
        children: props.children
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Description);
Description.propTypes = {};
Description.defaultProps = {};
var Descriptions = function(_param) {
    var list = _param.list, wrapper = _param.wrapper, contentClass = _param.contentClass, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "list",
        "wrapper",
        "contentClass"
    ]);
    if ((list === null || list === void 0 ? void 0 : list.length) > 0) {
        if (wrapper) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, wrapper), {
                children: list.map(function(item, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: contentClass || "mb-4 last:mb-0",
                        dangerouslySetInnerHTML: {
                            __html: item
                        }
                    }, index);
                })
            }));
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: list.map(function(item, index) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: contentClass || "mb-4 last:mb-0",
                    dangerouslySetInnerHTML: {
                        __html: item
                    }
                }, index);
            })
        });
    } else {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    }
};

Descriptions.propTypes = {
    list: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().array),
    wrapper: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().object),
    contentClass: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string)
};
Descriptions.defaultProps = {
    list: [],
    contentClass: "mb-4 last:mb-0"
}; /** ========== */ 


/***/ }),

/***/ 73979:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4298);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



function FacebookMessenger() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), loading = ref[0], setLoading = ref[1];
    // useEffect(() => {
    //   setTimeout(() => {
    //     setLoading(true);
    //   }, 6000);
    // }, []);
    var handleOnScroll = function(e) {
        if (!loading) setLoading(true);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        window.addEventListener("scroll", handleOnScroll, {
            passive: true
        });
        return function() {
            window.removeEventListener("scroll", handleOnScroll);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    id: "fb-root"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    id: "fb-customer-chat",
                    className: "fb-customerchat"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_1___default()), {
                    id: "facebook-messenger",
                    strategy: "lazyOnload",
                    children: "\n            var chatbox = document.getElementById('fb-customer-chat');\n            chatbox.setAttribute(\"page_id\", \"103158101213933\");\n            chatbox.setAttribute(\"attribution\", \"biz_inbox\");\n            \n            window.fbAsyncInit = function() {\n                FB.init({\n                xfbml            : true,\n                version          : 'v14.0'\n                });\n            };\n\n             (function(d, s, id) {\n        var js, fjs = d.getElementsByTagName(s)[0];\n        if (d.getElementById(id)) return;\n        js = d.createElement(s); js.id = id;\n        js.src = 'https://connect.facebook.net/vi_VN/sdk/xfbml.customerchat.js';\n        fjs.parentNode.insertBefore(js, fjs);\n      }(document, 'script', 'facebook-jssdk'));\n        "
                })
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {})
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (FacebookMessenger);


/***/ }),

/***/ 25081:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ FaFacebookF; }
/* harmony export */ });
/* harmony import */ var _iconBase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52624);

function FaFacebookF(props) {
    return (0,_iconBase__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"
                }
            }
        ]
    })(props);
}
;


/***/ }),

/***/ 46080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ FiChevronDown; }
/* harmony export */ });
/* harmony import */ var _iconBase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52624);

function FiChevronDown(props) {
    return (0,_iconBase__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "6 9 12 15 18 9"
                }
            }
        ]
    })(props);
}
;


/***/ }),

/***/ 52624:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w": function() { return /* binding */ GenIcon; }
});

// UNUSED EXPORTS: IconBase

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./components/atoms/Icon/iconContext.js

var DefaultContext = {
    color: undefined,
    size: undefined,
    className: undefined,
    style: undefined,
    attr: undefined
};
var IconContext = react.createContext && /*#__PURE__*/ (0,react.createContext)(DefaultContext);

;// CONCATENATED MODULE: ./components/atoms/Icon/iconBase.js


var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") for(var i = 0, p1 = Object.getOwnPropertySymbols(s); i < p1.length; i++){
        if (e.indexOf(p1[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p1[i])) t[p1[i]] = s[p1[i]];
    }
    return t;
};
function Tree2Element(tree) {
    return tree && tree.map(function(node, i) {
        return /*#__PURE__*/ (0,react.createElement)(node.tag, __assign({
            key: i
        }, node.attr), Tree2Element(node.child));
    });
}
function IconBase(props) {
    var elem = function elem(conf) {
        var attr = props.attr, size = props.size, title = props.title, svgProps = __rest(props, [
            "attr",
            "size",
            "title"
        ]);
        var computedSize = size || conf.size || "1em";
        var className;
        if (conf.className) className = conf.className;
        if (props.className) className = (className ? className + " " : "") + props.className;
        return /*#__PURE__*/ (0,react.createElement)("svg", __assign({
            stroke: "currentColor",
            fill: "currentColor",
            strokeWidth: "0"
        }, conf.attr, attr, svgProps, {
            className: className,
            style: __assign(__assign({
                color: props.color || conf.color
            }, conf.style), props.style),
            height: computedSize,
            width: computedSize,
            xmlns: "http://www.w3.org/2000/svg"
        }), title && /*#__PURE__*/ (0,react.createElement)("title", null, title), props.children);
    };
    return IconContext !== undefined ? /*#__PURE__*/ (0,react.createElement)(IconContext.Consumer, null, function(conf) {
        return elem(conf);
    }) : elem(DefaultContext);
}
// export function GenIcon({ data, ...props }) {
//   return React.createElement(
//     IconBase,
//     __assign(
//       {
//         attr: __assign({}, data.attr),
//       },
//       props
//     ),
//     Tree2Element(data.child)
//   );
// }
function GenIcon(data) {
    return function Generate(props) {
        return /*#__PURE__*/ (0,react.createElement)(IconBase, __assign({
            attr: __assign({}, data.attr)
        }, props), Tree2Element(data.child));
    };
} // export const IconKhoa = (props) => {
 //   return (
 //     <GenIcon
 //       data={{
 //         tag: "svg",
 //         attr: { viewBox: "0 0 1024 1024" },
 //         child: [
 //           {
 //             tag: "path",
 //             attr: {
 //               d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM327.3 702.4c-2 .9-4.4 0-5.3-2.1-.4-1-.4-2.2 0-3.2l98.7-225.5 132.1 132.1-225.5 98.7zm375.1-375.1l-98.7 225.5-132.1-132.1L697.1 322c2-.9 4.4 0 5.3 2.1.4 1 .4 2.1 0 3.2z",
 //             },
 //           },
 //         ],
 //       }}
 //       {...props}
 //     />
 //   );
 // };


/***/ }),

/***/ 57491:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ MdChecklist; }
/* harmony export */ });
/* harmony import */ var _iconBase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52624);

function MdChecklist(props) {
    return (0,_iconBase__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 7h-9v2h9V7zm0 8h-9v2h9v-2zM5.54 11L2 7.46l1.41-1.41 2.12 2.12 4.24-4.24 1.41 1.41L5.54 11zm0 8L2 15.46l1.41-1.41 2.12 2.12 4.24-4.24 1.41 1.41L5.54 19z"
                }
            }
        ]
    })(props);
}
;


/***/ }),

/***/ 47905:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ MdChecklistRtl; }
/* harmony export */ });
/* harmony import */ var _iconBase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52624);

function MdChecklistRtl(props) {
    return (0,_iconBase__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 7H2v2h9V7zm0 8H2v2h9v-2zm5.34-4L12.8 7.46l1.41-1.41 2.12 2.12 4.24-4.24L22 5.34 16.34 11zm0 8l-3.54-3.54 1.41-1.41 2.12 2.12 4.24-4.24L22 13.34 16.34 19z"
                }
            }
        ]
    })(props);
}
;


/***/ }),

/***/ 53097:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ MdOutlineCheckroom; }
/* harmony export */ });
/* harmony import */ var _iconBase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52624);

function MdOutlineCheckroom(props) {
    return (0,_iconBase__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.6 18.2L13 11.75v-.91a3.496 3.496 0 00-.18-6.75A3.51 3.51 0 008.5 7.5h2c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5c0 .84-.69 1.52-1.53 1.5-.54-.01-.97.45-.97.99v1.76L2.4 18.2c-.77.58-.36 1.8.6 1.8h18c.96 0 1.37-1.22.6-1.8zM6 18l6-4.5 6 4.5H6z"
                }
            }
        ]
    })(props);
}
;


/***/ }),

/***/ 55320:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ MdOutlineEmojiEvents; }
/* harmony export */ });
/* harmony import */ var _iconBase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52624);

function MdOutlineEmojiEvents(props) {
    return (0,_iconBase__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 5h-2V3H7v2H5c-1.1 0-2 .9-2 2v1c0 2.55 1.92 4.63 4.39 4.94A5.01 5.01 0 0011 15.9V19H7v2h10v-2h-4v-3.1a5.01 5.01 0 003.61-2.96C19.08 12.63 21 10.55 21 8V7c0-1.1-.9-2-2-2zM5 8V7h2v3.82C5.84 10.4 5 9.3 5 8zm7 6c-1.65 0-3-1.35-3-3V5h6v6c0 1.65-1.35 3-3 3zm7-6c0 1.3-.84 2.4-2 2.82V7h2v1z"
                }
            }
        ]
    })(props);
}
;


/***/ }),

/***/ 76933:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ MdOutlineFilterHdr; }
/* harmony export */ });
/* harmony import */ var _iconBase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52624);

function MdOutlineFilterHdr(props) {
    return (0,_iconBase__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 6l-4.22 5.63 1.25 1.67L14 9.33 19 16h-8.46l-4.01-5.37L1 18h22L14 6zM5 16l1.52-2.03L8.04 16H5z"
                }
            }
        ]
    })(props);
}
;


/***/ }),

/***/ 53104:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ MdOutlineLocalPrintshop; }
/* harmony export */ });
/* harmony import */ var _iconBase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52624);

function MdOutlineLocalPrintshop(props) {
    return (0,_iconBase__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 8h-1V3H6v5H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zM8 5h8v3H8V5zm8 14H8v-4h8v4zm2-4v-2H6v2H4v-4c0-.55.45-1 1-1h14c.55 0 1 .45 1 1v4h-2z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "11.5",
                    "r": "1"
                }
            }
        ]
    })(props);
}
;


/***/ }),

/***/ 90429:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ MdOutlineManageAccounts; }
/* harmony export */ });
/* harmony import */ var _iconBase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52624);

function MdOutlineManageAccounts(props) {
    return (0,_iconBase__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 18v-.65c0-.34.16-.66.41-.81C6.1 15.53 8.03 15 10 15c.03 0 .05 0 .08.01.1-.7.3-1.37.59-1.98-.22-.02-.44-.03-.67-.03-2.42 0-4.68.67-6.61 1.82-.88.52-1.39 1.5-1.39 2.53V20h9.26c-.42-.6-.75-1.28-.97-2H4zM10 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zM20.75 16c0-.22-.03-.42-.06-.63l1.14-1.01-1-1.73-1.45.49c-.32-.27-.68-.48-1.08-.63L18 11h-2l-.3 1.49c-.4.15-.76.36-1.08.63l-1.45-.49-1 1.73 1.14 1.01c-.03.21-.06.41-.06.63s.03.42.06.63l-1.14 1.01 1 1.73 1.45-.49c.32.27.68.48 1.08.63L16 21h2l.3-1.49c.4-.15.76-.36 1.08-.63l1.45.49 1-1.73-1.14-1.01c.03-.21.06-.41.06-.63zM17 18c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
                }
            }
        ]
    })(props);
}
;


/***/ }),

/***/ 59120:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ MdOutlineMedicalServices; }
/* harmony export */ });
/* harmony import */ var _iconBase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52624);

function MdOutlineMedicalServices(props) {
    return (0,_iconBase__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-4V4c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zM10 4h4v2h-4V4zm10 16H4V8h16v12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 10h-2v3H8v2h3v3h2v-3h3v-2h-3z"
                }
            }
        ]
    })(props);
}
;


/***/ }),

/***/ 62500:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ MdOutlineSettings; }
/* harmony export */ });
/* harmony import */ var _iconBase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52624);

function MdOutlineSettings(props) {
    return (0,_iconBase__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.43 12.98c.04-.32.07-.64.07-.98 0-.34-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46a.5.5 0 00-.61-.22l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65A.488.488 0 0014 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1a.566.566 0 00-.18-.03c-.17 0-.34.09-.43.25l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98 0 .33.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46a.5.5 0 00.61.22l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.06.02.12.03.18.03.17 0 .34-.09.43-.25l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zm-1.98-1.71c.04.31.05.52.05.73 0 .21-.02.43-.05.73l-.14 1.13.89.7 1.08.84-.7 1.21-1.27-.51-1.04-.42-.9.68c-.43.32-.84.56-1.25.73l-1.06.43-.16 1.13-.2 1.35h-1.4l-.19-1.35-.16-1.13-1.06-.43c-.43-.18-.83-.41-1.23-.71l-.91-.7-1.06.43-1.27.51-.7-1.21 1.08-.84.89-.7-.14-1.13c-.03-.31-.05-.54-.05-.74s.02-.43.05-.73l.14-1.13-.89-.7-1.08-.84.7-1.21 1.27.51 1.04.42.9-.68c.43-.32.84-.56 1.25-.73l1.06-.43.16-1.13.2-1.35h1.39l.19 1.35.16 1.13 1.06.43c.43.18.83.41 1.23.71l.91.7 1.06-.43 1.27-.51.7 1.21-1.07.85-.89.7.14 1.13zM12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
                }
            }
        ]
    })(props);
}
;


/***/ }),

/***/ 62336:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ MdOutlineVerified; }
/* harmony export */ });
/* harmony import */ var _iconBase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52624);

function MdOutlineVerified(props) {
    return (0,_iconBase__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 11.99L20.56 9.2l.34-3.69-3.61-.82L15.4 1.5 12 2.96 8.6 1.5 6.71 4.69 3.1 5.5l.34 3.7L1 11.99l2.44 2.79-.34 3.7 3.61.82 1.89 3.2 3.4-1.47 3.4 1.46 1.89-3.19 3.61-.82-.34-3.69 2.44-2.8zm-3.95 1.48l-.56.65.08.85.18 1.95-1.9.43-.84.19-.44.74-.99 1.68-1.78-.77-.8-.34-.79.34-1.78.77-.99-1.67-.44-.74-.84-.19-1.9-.43.18-1.96.08-.85-.56-.65L3.67 12l1.29-1.48.56-.65-.09-.86-.18-1.94 1.9-.43.84-.19.44-.74.99-1.68 1.78.77.8.34.79-.34 1.78-.77.99 1.68.44.74.84.19 1.9.43-.18 1.95-.08.85.56.65 1.29 1.47-1.28 1.48z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.09 13.75l-2.32-2.33-1.48 1.49 3.8 3.81 7.34-7.36-1.48-1.49z"
                }
            }
        ]
    })(props);
}
;


/***/ }),

/***/ 86314:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11752);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);




/* eslint-disable @next/next/no-img-element */ 


var publicRuntimeConfig = (0,next_config__WEBPACK_IMPORTED_MODULE_1__["default"])().publicRuntimeConfig;
var publicOptions = publicRuntimeConfig.publicOptions;
var path = __webpack_require__(62520);
/** ========== */ /**
 *
 * @param {{
 * image;
 * src;
 * alt;
 * placeholder;
 * priority;
 * wrapper:{className,style};
 * width:String|Number;
 * heightString|Number;
 * }} props Props for the component
 *
 */ var ratioScreen = {
    sm: 375,
    md: 768,
    lg: 1280
};
var ImgUse = function(_param) {
    var image = _param.image, src = _param.src, alt = _param.alt, placeholder = _param.placeholder, priority = _param.priority, wrapper = _param.wrapper, width = _param.width, height = _param.height, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "image",
        "src",
        "alt",
        "placeholder",
        "priority",
        "wrapper",
        "width",
        "height"
    ]);
    var srcStatic = src ? src.replace(/^\/+/, "") : placeholder.replace(/^\/+/, "");
    if (image && image.constructor === Object && Object.keys(image).length !== 0) {
        var ref, ref1;
        var webpEnable = publicOptions === null || publicOptions === void 0 ? void 0 : (ref = publicOptions.options) === null || ref === void 0 ? void 0 : (ref1 = ref.acf) === null || ref1 === void 0 ? void 0 : ref1.webpEnable;
        if (webpEnable) {
            var ref2, ref3, ref4, ref5, ref6, ref7;
            var webpSeparateFolder = publicOptions === null || publicOptions === void 0 ? void 0 : (ref2 = publicOptions.options) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.acf) === null || ref3 === void 0 ? void 0 : ref3.webpSeparateFolder;
            var defaultPath = "/wp-content/uploads";
            var separatePath = "/wp-content/webp-express/webp-images/uploads";
            var srcSet = [];
            var originalSize = "".concat(image === null || image === void 0 ? void 0 : image.sourceUrl, ".webp ").concat(image === null || image === void 0 ? void 0 : (ref4 = image.mediaDetails) === null || ref4 === void 0 ? void 0 : ref4.width, "w");
            originalSize = webpSeparateFolder ? originalSize.split(defaultPath).join(separatePath) : originalSize;
            srcSet.push(originalSize);
            var sizes = (image === null || image === void 0 ? void 0 : (ref5 = image.mediaDetails) === null || ref5 === void 0 ? void 0 : ref5.sizes) || [];
            if (sizes.length > 0) {
                sizes.forEach(function(size) {
                    var newSize = "".concat(size === null || size === void 0 ? void 0 : size.sourceUrl, ".webp ").concat(size === null || size === void 0 ? void 0 : size.width, "w");
                    newSize = webpSeparateFolder ? newSize.split(defaultPath).join(separatePath) : newSize;
                    srcSet.push(newSize);
                });
            }
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, wrapper), {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("picture", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                                type: "image/webp",
                                srcSet: srcSet.join(", "),
                                sizes: image === null || image === void 0 ? void 0 : image.sizes
                            }, props)),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props), {
                                loading: "".concat(priority ? null : "lazy"),
                                decoding: "async",
                                src: image === null || image === void 0 ? void 0 : image.sourceUrl,
                                srcSet: image === null || image === void 0 ? void 0 : image.srcSet,
                                sizes: image === null || image === void 0 ? void 0 : image.sizes,
                                width: image === null || image === void 0 ? void 0 : (ref6 = image.mediaDetails) === null || ref6 === void 0 ? void 0 : ref6.width,
                                height: image === null || image === void 0 ? void 0 : (ref7 = image.mediaDetails) === null || ref7 === void 0 ? void 0 : ref7.height,
                                alt: (image === null || image === void 0 ? void 0 : image.altText) ? image === null || image === void 0 ? void 0 : image.altText : alt,
                                title: (image === null || image === void 0 ? void 0 : image.altText) ? image === null || image === void 0 ? void 0 : image.altText : alt
                            }))
                        ]
                    })
                }))
            });
        } else {
            var ref8, ref9;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, wrapper), {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props), {
                        loading: "".concat(priority ? null : "lazy"),
                        decoding: "async",
                        src: image === null || image === void 0 ? void 0 : image.sourceUrl,
                        srcSet: image === null || image === void 0 ? void 0 : image.srcSet,
                        sizes: image === null || image === void 0 ? void 0 : image.sizes,
                        width: image === null || image === void 0 ? void 0 : (ref8 = image.mediaDetails) === null || ref8 === void 0 ? void 0 : ref8.width,
                        height: image === null || image === void 0 ? void 0 : (ref9 = image.mediaDetails) === null || ref9 === void 0 ? void 0 : ref9.height,
                        alt: (image === null || image === void 0 ? void 0 : image.altText) ? image === null || image === void 0 ? void 0 : image.altText : alt
                    }))
                }))
            });
        }
    } else {
        var extname = path.extname(srcStatic).toLowerCase();
        var isPng = extname.localeCompare(".png") == 0;
        var isJpeg = extname.localeCompare(".jpg") == 0 || extname.localeCompare(".jpeg") == 0;
        if (isPng || isJpeg) {
            var srcSplit = srcStatic.split(".")[0];
            var srcArr = srcSplit.split("/");
            var srcOptimize = "assets/optimize-images/".concat(srcArr[srcArr.length - 1]);
            var ratio_sm = ratioScreen.sm / width;
            var ratio_md = ratioScreen.md / width;
            var ratio_lg = ratioScreen.lg / width;
            var sm = {
                width: ratioScreen.sm,
                height: Math.round(ratio_sm * height)
            };
            var md = {
                width: ratioScreen.md,
                height: Math.round(ratio_md * height)
            };
            var lg = {
                width: ratioScreen.lg,
                height: Math.round(ratio_lg * height)
            };
            if (width <= ratioScreen.sm) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        priority && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                                rel: "preload",
                                href: "".concat(publicOptions.basePath, "/").concat(srcOptimize, "-").concat(width, "x").concat(height, ".webp"),
                                as: "image",
                                type: "image/webp",
                                media: "(max-width: ".concat(sm.width, "px)")
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, wrapper), {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("picture", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                                        type: "image/webp",
                                        srcSet: "".concat(publicOptions.basePath, "/").concat(srcOptimize, "-").concat(width, "x").concat(height, ".webp"),
                                        media: "(max-width: ".concat(sm.width, "px)")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                                        loading: "".concat(priority ? null : "lazy"),
                                        decoding: "async",
                                        srcSet: "".concat(publicOptions.basePath, "/").concat(srcStatic),
                                        alt: alt,
                                        width: width,
                                        height: height
                                    }, props))
                                ]
                            })
                        }))
                    ]
                });
            } else if (width > ratioScreen.sm && width < ratioScreen.md) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        priority && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                                    rel: "preload",
                                    href: "".concat(publicOptions.basePath, "/").concat(srcOptimize, "-").concat(sm.width, "x").concat(sm.height, ".webp"),
                                    as: "image",
                                    type: "image/webp",
                                    media: "(max-width: ".concat(sm.width, "px)")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                                    rel: "preload",
                                    href: "".concat(publicOptions.basePath, "/").concat(srcOptimize, "-").concat(width, "x").concat(height, ".webp"),
                                    as: "image",
                                    type: "image/webp",
                                    media: "(min-width: ".concat(sm.width + 1, "px) and (max-width: ").concat(md.width - 1, "px)")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, wrapper), {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("picture", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                                        type: "image/webp",
                                        srcSet: "".concat(publicOptions.basePath, "/").concat(srcOptimize, "-").concat(sm.width, "x").concat(sm.height, ".webp"),
                                        media: "(max-width: ".concat(sm.width, "px)")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                                        type: "image/webp",
                                        srcSet: "".concat(publicOptions.basePath, "/").concat(srcOptimize, "-").concat(width, "x").concat(height, ".webp"),
                                        media: "(min-width: ".concat(sm.width + 1, "px) and (max-width: ").concat(md.width - 1, "px)")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                                        loading: "".concat(priority ? null : "lazy"),
                                        decoding: "async",
                                        srcSet: "".concat(publicOptions.basePath, "/").concat(srcStatic),
                                        alt: alt,
                                        width: width,
                                        height: height
                                    }, props))
                                ]
                            })
                        }))
                    ]
                });
            } else if (width >= 768 && width <= 1279) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        priority && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                                    rel: "preload",
                                    href: "".concat(publicOptions.basePath, "/").concat(srcOptimize, "-").concat(sm.width, "x").concat(sm.height, ".webp"),
                                    as: "image",
                                    type: "image/webp",
                                    media: "(max-width: ".concat(sm.width, "px)")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                                    rel: "preload",
                                    href: "".concat(publicOptions.basePath, "/").concat(srcOptimize, "-").concat(md.width, "x").concat(md.height, ".webp"),
                                    as: "image",
                                    type: "image/webp",
                                    media: "(min-width: ".concat(sm.width + 1, "px) and (max-width: ").concat(md.width - 1, "px)")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                                    rel: "preload",
                                    href: "".concat(publicOptions.basePath, "/").concat(srcOptimize, "-").concat(width, "x").concat(height, ".webp"),
                                    as: "image",
                                    type: "image/webp",
                                    media: "(min-width: ".concat(md.width, "px) and (max-width: ").concat(ratioScreen.lg - 1, "px)")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, wrapper), {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("picture", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                                        type: "image/webp",
                                        srcSet: "".concat(publicOptions.basePath, "/").concat(srcOptimize, "-").concat(sm.width, "x").concat(sm.height, ".webp"),
                                        media: "(max-width: ".concat(sm.width, "px)")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                                        type: "image/webp",
                                        srcSet: "".concat(publicOptions.basePath, "/").concat(srcOptimize, "-").concat(md.width, "x").concat(md.height, ".webp"),
                                        media: "(min-width: ".concat(sm.width + 1, "px) and (max-width: ").concat(md.width - 1, "px)")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                                        type: "image/webp",
                                        srcSet: "".concat(publicOptions.basePath, "/").concat(srcOptimize, "-").concat(width, "x").concat(height, ".webp"),
                                        media: "(min-width: ".concat(md.width, "px) and (max-width: ").concat(lg.width - 1, "px)")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                                        loading: "".concat(priority ? null : "lazy"),
                                        decoding: "async",
                                        srcSet: "".concat(publicOptions.basePath, "/").concat(srcStatic),
                                        alt: alt,
                                        width: width,
                                        height: height
                                    }, props))
                                ]
                            })
                        }))
                    ]
                });
            } else if (width >= 1280) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        priority && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                                    rel: "preload",
                                    href: "".concat(publicOptions.basePath, "/").concat(srcOptimize, "-").concat(sm.width, "x").concat(sm.height, ".webp"),
                                    as: "image",
                                    type: "image/webp",
                                    media: "(max-width: ".concat(sm.width, "px)")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                                    rel: "preload",
                                    href: "".concat(publicOptions.basePath, "/").concat(srcOptimize, "-").concat(md.width, "x").concat(md.height, ".webp"),
                                    as: "image",
                                    type: "image/webp",
                                    media: "(min-width: ".concat(sm.width + 1, "px) and (max-width: ").concat(md.width - 1, "px)")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                                    rel: "preload",
                                    href: "".concat(publicOptions.basePath, "/").concat(srcOptimize, "-").concat(lg.width, "x").concat(lg.height, ".webp"),
                                    as: "image",
                                    type: "image/webp",
                                    media: "(min-width: ".concat(md.width, "px) and (max-width: ").concat(ratioScreen.lg - 1, "px)")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                                    rel: "preload",
                                    href: "".concat(publicOptions.basePath, "/").concat(srcOptimize, "-").concat(lg.width, "x").concat(lg.height, ".webp"),
                                    as: "image",
                                    type: "image/webp",
                                    media: "min-width: ".concat(lg.width, "px")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, wrapper), {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("picture", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                                        type: "image/webp",
                                        srcSet: "".concat(publicOptions.basePath, "/").concat(srcOptimize, "-").concat(sm.width, "x").concat(sm.height, ".webp"),
                                        media: "(max-width: ".concat(sm.width, "px)")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                                        type: "image/webp",
                                        srcSet: "".concat(publicOptions.basePath, "/").concat(srcOptimize, "-").concat(md.width, "x").concat(md.height, ".webp"),
                                        media: "(min-width: ".concat(sm.width + 1, "px) and (max-width: ").concat(md.width - 1, "px)")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                                        type: "image/webp",
                                        srcSet: "".concat(publicOptions.basePath, "/").concat(srcOptimize, "-").concat(lg.width, "x").concat(lg.height, ".webp"),
                                        media: "(min-width: ".concat(md.width, "px) and (max-width: ").concat(lg.width - 1, "px)")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                                        type: "image/webp",
                                        srcSet: "".concat(publicOptions.basePath, "/").concat(srcOptimize, "-").concat(lg.width, "x").concat(lg.height, ".webp"),
                                        media: "min-width: ".concat(lg.width, "px")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                                        loading: "".concat(priority ? null : "lazy"),
                                        decoding: "async",
                                        srcSet: "".concat(publicOptions.basePath, "/").concat(srcStatic),
                                        alt: alt,
                                        width: width,
                                        height: height
                                    }, props))
                                ]
                            })
                        }))
                    ]
                });
            }
        } else {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    priority && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                            rel: "preload",
                            as: "image",
                            href: "".concat(publicOptions.basePath, "/").concat(srcStatic)
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, wrapper), {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                            loading: "".concat(priority ? null : "lazy"),
                            decoding: "async",
                            src: "".concat(publicOptions.basePath, "/").concat(srcStatic),
                            alt: alt,
                            width: width,
                            height: height
                        }, props))
                    }))
                ]
            });
        }
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            priority && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                    rel: "preload",
                    as: "image",
                    href: "".concat(publicOptions.basePath, "/").concat(srcStatic)
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, wrapper), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props), {
                    loading: "".concat(priority ? null : "lazy"),
                    decoding: "async",
                    src: "".concat(publicOptions.basePath, "/").concat(srcStatic),
                    alt: alt
                }))
            }))
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ImgUse);
ImgUse.propTypes = {
    image: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().object),
    src: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    alt: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    placeholder: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    priority: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().bool),
    wrapper: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().object)
};
ImgUse.defaultProps = {
    image: {},
    src: null,
    alt: "placeholder",
    placeholder: "assets/common/placeholder.jpg",
    priority: false,
    wrapper: {
        className: "inline-block"
    }
}; /** ========== */ 


/***/ }),

/***/ 72196:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

function ListStyleLI(param) {
    var data = param.data, children = param.children, className = param.className, onClick = param.onClick;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
        className: "".concat(className || "", " list-disc marker:text-gleads-buttonBlue-500"),
        onClick: onClick,
        children: data || children
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (ListStyleLI);


/***/ }),

/***/ 34589:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ModalBody": function() { return /* binding */ ModalBody; },
/* harmony export */   "ModalFooter": function() { return /* binding */ ModalFooter; },
/* harmony export */   "ModalHeader": function() { return /* binding */ ModalHeader; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(56727);
/* harmony import */ var _Icon_fa_FaTimes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55204);








var ModalHeader = function(_param) {
    var children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props), {
        children: children
    }));
};
/* components */ 
var ModalBody = function(_param) {
    var children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props), {
        children: children
    }));
};

var ModalFooter = function(_param) {
    var children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props), {
        children: children
    }));
};

/**
 *
 * @param {{
 * size: "sm" | "md" | "lg" | "xl"
 * }} props Props for the component
 *
 */ var ModalDialog = function(_param) {
    var data = _param.data, isOpen = _param.isOpen, closeButton = _param.closeButton, callback = _param.callback, cancelCallBack = _param.cancelCallBack, children = _param.children, size = _param.size, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "data",
        "isOpen",
        "closeButton",
        "callback",
        "cancelCallBack",
        "children",
        "size"
    ]);
    var CloseButton = closeButton;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isShow = ref[0], setIsShow = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), modalSize = ref1[0], setModalSize = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setIsShow(isOpen);
    }, [
        isOpen
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        // switch (size) {
        //   case "xs":
        //     setModalSize("w-full lg:w-1/2");
        //     break;
        //   case "sm":
        //     setModalSize("w-full md:w-1/2 lg:w-2/3");
        //     break;
        //   case "md":
        //     setModalSize("w-full md:w-2/3 lg:w-3/4");
        //     break;
        //   case "lg":
        //     setModalSize("w-full md:w-4/5 lg:w-3/5");
        //     break;
        //   case "xl":
        //     setModalSize("w-full md:w-full lg:w-5/6");
        //     break;
        //   default:
        //     setModalSize("lg:w-full");
        //     break;
        // }
        switch(size){
            case "xs":
                setModalSize("w-full lg:w-3/12");
                break;
            case "sm":
                setModalSize("w-full lg:w-4/12");
                break;
            case "md":
                setModalSize("w-full lg:w-6/12");
                break;
            case "lg":
                setModalSize("w-full lg:w-8/12");
                break;
            case "xl":
                setModalSize("w-full lg:w-10/12");
                break;
            default:
                setModalSize("lg:w-full");
                break;
        }
    }, [
        size
    ]);
    var handleClose = function() {
        setIsShow(false);
        cancelCallBack && cancelCallBack();
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_6__/* .Transition */ .uT, {
            appear: true,
            show: isShow,
            as: react__WEBPACK_IMPORTED_MODULE_1__.Fragment,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_6__/* .Dialog */ .Vq, {
                as: "div",
                className: "fixed inset-0 overflow-y-auto",
                style: {
                    zIndex: 100
                },
                onClose: handleClose,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "min-h-screen px-4 text-center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_6__/* .Transition.Child */ .uT.Child, {
                            as: react__WEBPACK_IMPORTED_MODULE_1__.Fragment,
                            enter: "ease-out duration-300",
                            enterFrom: "opacity-0",
                            enterTo: "opacity-100",
                            leave: "ease-in duration-200",
                            leaveFrom: "opacity-100",
                            leaveTo: "opacity-0",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_6__/* .Dialog.Overlay */ .Vq.Overlay, {
                                className: "fixed inset-0 bg-slate-900 opacity-70"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "inline-block h-screen align-middle",
                            "aria-hidden": "true",
                            children: "\u200B"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_6__/* .Transition.Child */ .uT.Child, {
                            as: react__WEBPACK_IMPORTED_MODULE_1__.Fragment,
                            enter: "ease-out duration-300",
                            enterFrom: "opacity-0 scale-95",
                            enterTo: "opacity-100 scale-100",
                            leave: "ease-in duration-200",
                            leaveFrom: "opacity-100 scale-100",
                            leaveTo: "opacity-0 scale-95",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "relative inline-flex transform flex-col justify-center rounded-2xl border-2 bg-white text-left align-middle shadow-xl transition-all ".concat(modalSize),
                                style: props.style,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "absolute top-4 right-4 z-10",
                                        children: /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.isValidElement)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CloseButton, {})) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CloseButton, {
                                            onClick: handleClose
                                        })
                                    }),
                                    children
                                ]
                            })
                        })
                    ]
                })
            })
        })
    });
};
ModalDialog.propTypes = {
    closeButton: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().any)
};
ModalDialog.defaultProps = {
    closeButton: function(props) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
            type: "button",
            className: "inline-flex justify-center rounded-full border-none p-1 text-xl font-medium transition-all focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2",
            onClick: props.onClick,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon_fa_FaTimes__WEBPACK_IMPORTED_MODULE_2__/* .FaTimes */ .a, {
                size: 21
            })
        });
    }
};
/* harmony default export */ __webpack_exports__["default"] = (ModalDialog); // export default Object.assign(ModalDialog, {
 //   Header: Header,
 //   Body: Body,
 //   Footer: Footer,
 // });


/***/ }),

/***/ 17499:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var common_functions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6644);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _Index_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89876);
/* harmony import */ var _Index_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Index_module_scss__WEBPACK_IMPORTED_MODULE_4__);








/**
 *
 * @param {{
 * as: "div"|"h1"| "h2"|"h3"|"h4"|"h5";
 * title: {content:String, default_word_color:String, highlight_word_colors:Array|String, highlight_word_list:Array};
 * othersClass;
 * className;
 * }} props Props for the component
 *
 */ var Title = function(_param) {
    var title = _param.title, text = _param.text, as = _param.as, id = _param.id, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "title",
        "text",
        "as",
        "id",
        "children"
    ]);
    var As = as || "h2";
    var textSize = function(as) {
        var text_size = "";
        switch(as){
            case "h1":
                {
                    text_size = "".concat((_Index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().h1));
                    break;
                }
            case "h2":
                {
                    text_size = "".concat((_Index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().h2));
                    break;
                }
            case "h3":
                {
                    text_size = "".concat((_Index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().h3));
                    break;
                }
            case "h4":
                {
                    text_size = "".concat((_Index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().h4));
                    break;
                }
            default:
                break;
        }
        return text_size;
    };
    var hightLightTitle = function(titleProps) {
        var list_highlight = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, titleProps).highlight_word_list || [];
        var clone_title = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, titleProps).content || "";
        var isArray_highlight_word_colors = Array.isArray(titleProps === null || titleProps === void 0 ? void 0 : titleProps.highlight_word_colors);
        list_highlight.forEach(function(word, wordIndx) {
            var split_word_arr = clone_title.split(word);
            clone_title = split_word_arr.join('<span class="'.concat(isArray_highlight_word_colors ? titleProps === null || titleProps === void 0 ? void 0 : titleProps.highlight_word_colors[wordIndx] : (titleProps === null || titleProps === void 0 ? void 0 : titleProps.highlight_word_colors) || "text-gleads-pink-600", '">').concat(word, "</span>"));
        });
        return clone_title;
    };
    var generateElementByParse = function(string) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(As, {
            id: id ? id : null,
            className: props.className || (0,common_functions__WEBPACK_IMPORTED_MODULE_1__/* .classNames */ .A)((_Index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().title), (title === null || title === void 0 ? void 0 : title.default_word_color) || "text-gleads-oxfordBlue-700", textSize(as), props.othersClass),
            dangerouslySetInnerHTML: {
                __html: string
            }
        });
    };
    if (title) {
        return generateElementByParse(hightLightTitle(title));
    } else {
        if ((children === null || children === void 0 ? void 0 : children.constructor) === String) {
            return generateElementByParse(children);
        } else {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(As, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                id: id ? id : null
            }, props), {
                className: props.className || (0,common_functions__WEBPACK_IMPORTED_MODULE_1__/* .classNames */ .A)((_Index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().title), textSize(as), props.othersClass),
                children: children
            }));
        }
    }
};
Title.propTypes = {
    text: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    as: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    id: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string)
};
Title.defaultProps = {
    text: null,
    as: "h2"
};
/* harmony default export */ __webpack_exports__["Z"] = (Title);


/***/ }),

/***/ 35035:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4298);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



var zaloWidget = '<div\nclass="zalo-chat-widget"\ndata-oaid="536303807395273679"\ndata-welcome-message="R\u1EA5t vui khi \u0111\u01B0\u1EE3c h\u1ED7 tr\u1EE3 b\u1EA1n!"\ndata-autopopup="0"\ndata-width="350"\ndata-height="420"\n/>';
function Zalo() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), loading = ref[0], setLoading = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        setTimeout(function() {
            setLoading(true);
        }, 6000);
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: zaloWidget
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_1___default()), {
                    strategy: "lazyOnload",
                    src: "https://sp.zalo.me/plugins/sdk.js"
                })
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Zalo);


/***/ }),

/***/ 98504:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"animate-balloon":"Index_animate-balloon__gg0aK","animate-balloons-X":"Index_animate-balloons-X__RQ61T","balloons-X":"Index_balloons-X__IfxR_","animate-balloons-Y":"Index_animate-balloons-Y__CnoRA","balloons-Y":"Index_balloons-Y__yi8oT","animate-balloons-X-mobile":"Index_animate-balloons-X-mobile__TRAIa","animate-balloons-Y-mobile":"Index_animate-balloons-Y-mobile__uk4pU"};

/***/ }),

/***/ 89876:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"Index_title__QAP_z","h1":"Index_h1__LA4wg","h2":"Index_h2__MtYs9","h3":"Index_h3__5vc_x","h4":"Index_h4__WbNee"};

/***/ })

}]);